import { render, staticRenderFns } from "./ListSubModality.vue?vue&type=template&id=2b7e5ef3"
import script from "./ListSubModality.vue?vue&type=script&lang=js"
export * from "./ListSubModality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports